import React, { useState } from 'react';
import { MdArrowBackIos } from 'react-icons/md';
import Moment from 'react-moment';
import { useDispatch, useSelector } from 'react-redux';
import { niceBytes } from '../../../Utils/Common';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { setPopup } from '../../../redux/messageSlice';
import Axios from "axios";
import { HiOutlineZoomIn } from "react-icons/hi";
import { HiOutlineZoomOut } from "react-icons/hi";
import { IoIosArrowRoundDown } from "react-icons/io";


const FileDownload = require('js-file-download');

const FileViewPopup = ({ setFileViewPopup }) => {
    const dispatch = useDispatch();
    const { active_file, downloading_progress } = useSelector(state => state.message)
    console.log("🚀 ~ FileViewPopup ~ active_file:", active_file)


    let [url_loading, setUrlLoading] = useState(true)
    const zoomLevels = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
    const [selectedZoom, setSelectedZoom] = useState(100);
    const [showZoomPanel, setShowZoomPanel] = useState(false);
    const onComplete = () => {
        setUrlLoading(false)
    }

    const handleZoomSelect = (level, transformFunctions, currentState) => {
        setSelectedZoom(level);
        setShowZoomPanel(false); // Close panel after selection

        if (transformFunctions && transformFunctions.setTransform) {
            const targetScale = level / 100;

            // Get the container dimensions to calculate center point
            const containerElement = document.querySelector('.react-transform-component');
            if (containerElement) {
                const containerRect = containerElement.getBoundingClientRect();
                const centerX = containerRect.width / 2;
                const centerY = containerRect.height / 2;

                // Calculate the position to keep zoom centered
                const currentScale = currentState?.scale || 1;
                const scaleRatio = targetScale / currentScale;

                // Calculate new position to maintain center point
                const currentX = currentState?.positionX || 0;
                const currentY = currentState?.positionY || 0;

                const newX = centerX - (centerX - currentX) * scaleRatio;
                const newY = centerY - (centerY - currentY) * scaleRatio;

                transformFunctions.setTransform(newX, newY, targetScale, 200, 'easeOut');
            } else {
                // Fallback to simple center transform
                transformFunctions.setTransform(0, 0, targetScale, 200, 'easeOut');
            }
        }
    };

    const AfileDownload = (url, filename) => {
        console.log(url, filename);

        dispatch(setPopup({ key: 'downloading_file', value: [filename] }))
        if (downloading_progress[filename]) return
        dispatch(setPopup({ key: 'downloading_progress', value: { ...downloading_progress, [filename]: 'Downloading...' } }))
        Axios({
            url: url,
            method: 'GET',
            responseType: 'blob',
            onDownloadProgress(progressEvent) {
                let progress = Math.floor((progressEvent.loaded / progressEvent.total) * 100) + "%";
                dispatch(setPopup({ key: 'downloading_progress', value: { ...downloading_progress, [filename]: progress } }))
            }
        }).then((response) => {
            FileDownload(response.data, filename);
            let d_progress = { ...downloading_progress };
            d_progress = { ...(delete d_progress[filename] && d_progress) }
            dispatch(setPopup({ key: 'downloading_progress', value: d_progress }))
        });
    }

    return (
        <div className='fixed top-0 left-0 w-full h-full z-[100] bg-white  '>
            <div className='chat_Header !top-0'>
                <div className='chat_HeaderContainer'>
                    <div className='chat_HeaderIcon -mt-2 ml-2' onClick={() => setFileViewPopup(false)}>
                        <MdArrowBackIos className="thread_eHeaderIcon text-2xl !mr-0" />
                    </div>
                    <div className="chatHeadLeftside">
                        <p className='text-white'>Chat</p>
                    </div>
                </div>
            </div>
            <div className='bg-white'>
                <div className='h-[calc(100%-65px)] !mt-0 _msgContainer'>
                    <div className="chatHeadLeftside p-5 w-full">
                        <p className='text-grey-600 text-sm text-center break-all'>{active_file?.originalname} ({niceBytes(active_file?.file_size)})</p>
                        <p className='text-grey-600 text-sm text-center'>{active_file?.uploaded_by} on <Moment format="DD/MM/YYYY h:mm a">{active_file?.created_at}</Moment></p>
                    </div>
                    <div className='flex gap-1 m-3'>
                        <TransformWrapper
                            // initialScale={1}
                            // disablePadding={true}
                            limitToBounds={true}
                            centerZoomedOut={true}
                            centerOnInit={true}
                            // initialPositionX={200}
                            // initialPositionY={300}
                            smooth={true}
                            onZoomStop={(instance) => {
                                const state = instance?.state;
                                if (!state) return;
                                const currentScale = state.scale * 100;
                                const nearestLevel = zoomLevels.reduce((prev, curr) => Math.abs(curr - currentScale) < Math.abs(prev - currentScale) ? curr : prev, zoomLevels[0]);
                                setSelectedZoom(nearestLevel);
                            }}>

                            {({ zoomIn, zoomOut, resetTransform, setTransform, state }) => (
                                <React.Fragment>
                                    {showZoomPanel && (
                                        <>
                                            {/* Backdrop to close panel when clicking outside */}
                                            <div
                                                className='fixed inset-0 z-[98]'
                                                onClick={() => setShowZoomPanel(false)}
                                            />
                                            <div style={{ zIndex: 99 }} className='w-[20%] absolute bottom-24 left-[66px] bg-white rounded border border-teal-200 flex flex-col-reverse gap-2.5 justify-center items-center shadow-lg'>
                                                {zoomLevels.map(level => {
                                                    const isActive = selectedZoom === level;
                                                    const baseClasses = 'text-sm w-full text-center h-6 rounded transition-colors duration-150';
                                                    const activeClasses = 'text-teal-600 dark:text-white font-bold bg-teal-100 dark:bg-teal-600/30';
                                                    const inactiveClasses = 'text-text-body dark:text-white hover:text-teal-600 hover:bg-teal-100 dark:hover:bg-teal-600/10';
                                                    return (
                                                        <button
                                                            key={level}
                                                            type='button'
                                                            onClick={() => handleZoomSelect(level, { zoomIn, zoomOut, setTransform }, state)}
                                                            className={`${baseClasses} ${isActive ? activeClasses : inactiveClasses}`}
                                                        >
                                                            {level}%
                                                        </button>
                                                    );
                                                })}
                                            </div>
                                        </>
                                    )}
                                    <TransformComponent >
                                        <div className={`p-5 flex flex-col justify-center items-center w-full`}>
                                            {url_loading && <p>Loading...</p>}
                                            <img className='w-[350px] h-[350px] object-contain m-auto' onLoad={onComplete} src={active_file?.location} alt="preview" title="preview" style={{ cursor: 'pointer' }} />
                                        </div>
                                    </TransformComponent>
                                    {/* <div className="tools">
                                    <button onClick={() => zoomIn()}>Zoom In +</button>
                                    <button onClick={() => zoomOut()}>Zoom Out -</button>
                                    <button id="resetZoom" onClick={() => resetTransform()}>Reset</button>
                                    <button onClick={() => AfileDownload(active_file?.location, active_file?.originalname)}>Download</button>
                                </div> */}
                                    <div className='absolute bottom-0 left-1/2 transform -translate-x-1/2 pb-10'>
                                        <div className='p-5 flex gap-3 justify-center items-center'>
                                            <div
                                                className="flex w-[74px] h-[28px] gap-1 text-sm items-center justify-center py-1 px-3 border border-teal-200 rounded-full text-teal-600 cursor-pointer hover:bg-teal-100 transition-colors"
                                                onClick={() => setShowZoomPanel(!showZoomPanel)}
                                            >
                                                {selectedZoom}%
                                            </div>
                                            <div className='flex gap-4 items-center py-1 px-3 border border-teal-200 dark:border-white rounded-full text-teal-600 dark:text-white h-[28px]'>
                                                <HiOutlineZoomIn className='text-sm' onClick={() => zoomIn()} />
                                                <HiOutlineZoomOut className='text-sm' onClick={() => zoomOut()} />
                                            </div>
                                            {/* <div
                                                onClick={() => {
                                                    resetTransform();
                                                    setSelectedZoom(100);
                                                }}
                                                className='flex gap-1 items-center py-1 px-2 border border-teal-200 rounded-full text-teal-600'
                                            >
                                                <p className='text-xs'>Reset</p>
                                            </div> */}
                                            <div onClick={() => AfileDownload(active_file?.location, active_file?.originalname)} className='flex h-[28px] gap-1 items-center py-1 pt-[5px] pl-4 px-2 rounded-full text-white bg-teal-600'>
                                                <p className='text-xs'>Download</p>
                                                <IoIosArrowRoundDown className='text-sm' />
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            )}
                        </TransformWrapper>
                    </div>

                    {/* <div className='p-5 flex flex-col justify-center items-center mt-20'>
                        <img
                            src={active_file?.location}
                            alt=''
                            title='image'
                            className='object-cover'
                        />
                    </div>
                    <div className='absolute bottom-0 pb-10 w-full'>
                        <div className='p-5 flex gap-1.5 justify-center items-center w-full'>
                            <div className='flex items-center py-1 px-2 border border-teal-200 rounded-full'>
                                <p className='text-xs'>Zoom In</p>
                                <MdAdd className='text-sm' />
                            </div>
                            <div className='flex items-center py-1 px-2 border border-teal-200 rounded-full'>
                                <p className='text-xs'>Zoom In</p>
                                <MdAdd className='text-sm' />
                            </div>
                            <div className='flex gap-1 items-center py-1 px-2 border border-teal-200 rounded-full'>
                                <p className='text-xs'>Reset</p>
                            </div>
                            <div className='flex gap-1 items-center py-1 px-2 border border-teal-200 rounded-full'>
                                <p className='text-xs'>Download</p>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default FileViewPopup;